// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  palette: {
    primary: {
      main: '#1e2a38',
    },
    secondary: {
      main: '#F2F7FF',
    },
  },
  components: {
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined',
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontSize: '13px',
          padding: '2px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.4)', // 🌟 Shadow added here
          borderRadius: '6px', // Optional: soft rounded corners

          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#273c75',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#273c75',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#273c75',
          },
        },
        input: {
          padding: '6px 10px',
        },
      },
    },

    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          fontWeight: 600,
          transform: 'translate(14px, 10px) scale(1)',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.85)',
          },
          '& .MuiInputLabel-asterisk': {
            color: 'red',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          fontSize: '13px',
          fontWeight: 800,
          textTransform: 'none',
          border: '1px solid #273c75',
          color: ownerState.variant === 'contained' ? '#fff' : '#273c75',
          backgroundColor: ownerState.variant === 'contained' ? '#273c75' : 'transparent',
          '&:hover': {
            backgroundColor: '#273c75',
            color: '#fff',
          },
        }),
      },
    },
    MuiTable: {
      defaultProps: {
        size: 'small',
        stickyHeader: true,
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          paddingTop: '2px',
          paddingBottom: '2px',
          paddingLeft: '6px',
          paddingRight: '6px',
          fontSize: '13px',
          textAlign: 'center', // ✅ Ensures all table cells are center-aligned
        },
        head: {
          fontWeight: 'bold',
          backgroundColor: '#d0d0d0',
          textAlign: 'center', // ✅ Ensures table header cells are also center-aligned
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: '32px',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          padding: '4px',
          '& .MuiSvgIcon-root': {
            borderRadius: 2,                // Optional: slightly rounded corners
            boxSizing: 'border-box',
          },
          '&.Mui-checked .MuiSvgIcon-root': {
            backgroundColor: '#273c75',    // Fill with blue when checked
            borderColor: '#273c75',        // Keep border blue when checked
            color: '#fff',                 // Checkmark color white
          },
          '&:hover .MuiSvgIcon-root': {
            borderColor: '#1e2a38',        // Darker blue border on hover
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '4px',
        },
      },
    },
    MuiDataGrid: {
      defaultProps: {
        density: 'compact',
        disableSelectionOnClick: true,
      },
      styleOverrides: {
        root: {
          border: 'none',
        },
        columnHeaders: {
          padding: 0,
          minHeight: '32px',
          backgroundColor: '#f2f2f2',
        },
        columnHeader: {
          px: 0,
          textAlign: 'center',
          '& .MuiDataGrid-columnHeaderTitleContainer': {
            justifyContent: 'center', // Center the container that holds the title
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            textAlign: 'center',
            width: '100%',
          },
        },
        cell: {
          py: 0,
          px: 0,
          fontSize: '13px',
          textAlign: 'center',
        },
        virtualScrollerRenderZone: {
          '& .MuiDataGrid-row': {
            minHeight: '32px',
          },
        },
        row: {
          '&.even': {
            backgroundColor: '#f6f6f6',
          },
          '&.odd': {
            backgroundColor: '#ffffff',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          minHeight: '34px',
          paddingTop: '4px',
          paddingBottom: '2px',
          '&.Mui-expanded': {
            minHeight: '34px',
          },
        },
        content: {
          margin: 0,
          paddingTop: '4px',
          '&.Mui-expanded': {
            margin: 0,
          },
        },
      },
    },

  },
});

export default theme;
